import { ElementType, IElement } from '../../../models/Element';

export type ProjectHighlights = IElement & {
  title: string;
  highlights: Array<IHighlight>;
};

export interface IHighlight {
  id: number;
  label_start: string;
  label_end: string;
  title: string;
  description: string;
}

export const defaultHighlight: IHighlight = {
  id: 0,
  label_start: 'Strategy',
  label_end: 'Marketing',
  title: 'Benchmark',
  description:
    '5.8 percent of visitors directly order a product on the site. The benchmark is 3.1 percent.',
};

export const defaultProjectHighlights: ProjectHighlights = {
  id: 0,
  name: ElementType.PROJECT_HIGHLIGHTS,
  title: 'Project highlights',
  highlights: [defaultHighlight],
};

export enum ProjectHighlightsItemTypes {
  HIGHLIGHT = 'highlight',
}
